import React from "react";
import { Box, Paper, Skeleton, Stack, Typography } from "@mui/material";
import SubmitButton from "src/components/common/Buttons/SubmitButton";
import { colors } from "src/config/colors";
import Container from "src/components/common/Layout/Container";

const AnalogListSkeleton: React.FC = () => {
  return (
    <Container
      isWithPaper
      paddingX="0px"
      wrapperSx={{
        padding: "24px",
        borderRadius: "8px",
        mt: 3,
        paddingBottom: "34px",
      }}
      id="analogs"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          marginBottom: 3,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "16px", tb: "24px" },
            fontWeight: 500,
            color: colors.black2,
            mb: 5,
          }}
        >
          Аналоги
        </Typography>
        <Box
          sx={{
            padding: "10px 16px",
            display: "flex",
          }}
        >
          <Stack
            spacing={3}
            direction="row"
            width="100%"
            overflow="hidden"
            padding={1}
          >
            {Array.from({ length: 4 }).map((value, index) => (
              <Paper
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  padding: "16px",
                  borderRadius: "8px",
                  minWidth: "232px",
                  maxWidth: "232px",
                  minHeight: "370px",
                  margin: 0,
                  position: "relative",
                  boxShadow: "0px 3px 16px 0px rgba(12, 21, 57, 0.10)",
                }}
              >
                <Skeleton width="200px" height="110px" />
                <Skeleton width="200px" height="50px" />
                <Skeleton width="200px" height="30px" />
                <Skeleton width="200px" height="30px" />
                <SubmitButton
                  title="Подробнее"
                  maxWidth={200}
                  height={48}
                  sx={{ borderRadius: "8px" }}
                />
              </Paper>
            ))}
          </Stack>
        </Box>
      </Box>
    </Container>
  );
};

export default AnalogListSkeleton;
